import { useReducer } from "react";
import RegistrationContext from './registrationContext';
import registrationReducer from './registrationReducer';
import { REGISTER_SUCCESS } from './types'

const RegistrationState = (props) => {
    const initialState = {
        code: '',
        date: 'Saturday 4th of June, 2022',
        time: '10am',
        venue: 'Grand Hotel Convention Centre & Resort, 112 Nnebisi Road, Asaba Delta State'
    }

    const [state, dispatch] = useReducer(registrationReducer, initialState);


    const registrationComplete = (code) => {
        dispatch({
            type: REGISTER_SUCCESS, payload: code
        })
    }

    return (
        <RegistrationContext.Provider
            value={{
                registrationComplete,
                state
            }}
        >
            {props.children}
        </RegistrationContext.Provider>
    )

}

export default RegistrationState